import React, { useEffect } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { getDeposit, set_me } from '../../actions/user';
import { getBasket } from '../../actions/cartActions';
import MultiStepForm from './steps/steps';
import Invoice from './Invoice';
import { Redirect } from 'react-router-dom';
import { notNullAndUndefined } from '../../helper';

// استایل‌های CSS

function MarketPlaceInformationSteps({ set_me, getBasket, getDeposit, user }) {
  const [hoveredSection, setHoveredSection] = React.useState(null);

  useEffect(() => {
    set_me();
    getBasket();
    getDeposit();
  }, []);

  useEffect(() => {
    let tok = localStorage.getItem('token');
    if (notNullAndUndefined(tok)) {
      set_me();
    }
  }, []);

  // if (Object.keys(user).length === 0) {
  //   return <Redirect to='/' />;
  // }
  return (
    <>
      <style>{responsiveStyles}</style>
      <div style={styles.body}>
        <div style={styles.container}>
          <div className='layout-wrapper' style={styles.layoutWrapper}>
            <div
              className='section-one'
              style={{
                ...styles.section,
              }}
            >
              <MultiStepForm />
            </div>

            <div
              className='section-two'
              style={{
                ...styles.section,
                marginBottom: '180px !important',
              }}
            >
              <Invoice />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const MapStateToProps = (state) => {
  return {
    translate: getTranslate(state.localize),
    cart: state.cart.cart,
    user: state.user,
    sanad: state.cart.sanad,
    credit: state.cart.cart_credit,
    cart_report: state.cart.cart_report,
    order_address: state.cart.order_address,
    order_shipping: state.cart.order_shipping,
    price_shipping: state.cart.price_shipping,
    time_index: state.cart.time_index,
    date: state.cart.date,
    show_sanad: false,
  };
};

export default connect(MapStateToProps, { set_me, getBasket, getDeposit })(MarketPlaceInformationSteps);
const styles = {
  body: {
    backgroundColor: 'white',
    minHeight: '100vh',
    // padding: '20px',
    margin: 0,
    boxSizing: 'border-box',
  },

  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },

  layoutWrapper: {
    display: 'flex',
    flexDirection: 'column',
    paddingBlock: '20px',
    paddingBlockEnd: '40px',
    // gap: '20px',
  },

  section: {
    paddingInline: '30px',
    paddingBlock: '10px',
    borderRadius: '10px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    cursor: 'pointer',
  },

  sectionHover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
  },

  sectionTitle: {
    color: '#333',
    marginBottom: '15px',
    fontSize: '24px',
    fontWeight: 'bold',
  },

  sectionText: {
    color: '#666',
    lineHeight: '1.6',
    fontSize: '16px',
    marginTop: '15px',
  },
  // Media Query برای دسکتاپ
  '@media (min-width: 1024px)': {
    layoutWrapper: {
      flexDirection: 'row',
    },
    sectionOne: {
      flex: '0 0 60%',
    },
    sectionTwo: {
      flex: '0 0 40%',
    },
  },
};

// CSS در JS برای responsive
const responsiveStyles = `
@media (max-width: 768px) {
  .layout-wrapper {
    margin-top: 240px !important;
  }
  }
  @media (min-width: 1024px) {
    .layout-wrapper {
        margin-top: 230px !important;
      flex-direction: row-reverse !important;
    }
    .section-one {
      flex: 0 0 60% !important;
    }
    .section-two {
      flex: 0 0 40% !important;
      margin-bottom: 180 !important;
    }
  }
`;
